<script lang="ts">
	import Input from './input.svelte';
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import { newsletterFormVisible } from '$lib/stores/footer';
	import GridContainer from '../../routes/(marketing)/order-now/gridContainer.svelte';
	import Grid from '../../routes/(marketing)/order-now/grid.svelte';
	import SanityImage from '$lib/sanityImage.svelte';
	import { fade } from 'svelte/transition';

	let successfullyEntered = $state(false);
</script>

<div class="overflow-hidden bg-white lg:py-20">
	<GridContainer class="relative w-full lg:overflow-hidden lg:rounded-3xl">
		<SanityImage
			assetId="image-24a0a0e8929af8f4e2babe3468e2fd584988c5c4-780x560-png"
			variants={{
				768: {
					assetId: 'image-69d669c93d0e092417d67b9bbbc767a6e767ed1b-2500x857-png',
					width: 1800
				},
				1536: {
					assetId: 'image-69d669c93d0e092417d67b9bbbc767a6e767ed1b-2500x857-png',
					width: 2816
				}
			}}
			dimensions={{ width: 780 }}
			loading="lazy"
			alt=""
			class="absolute h-full w-full object-cover object-center"
		/>
		<div class="absolute inset-0 bg-brown-1/40"></div>
		<div
			class="relative py-6 text-stone-4 max-lg:px-8 sm:py-12 lg:py-28"
			use:checkVisibility={{ threshold: 0 }}
			onvisible={(e) => newsletterFormVisible.set(e.detail)}
		>
			<Grid margin={false}>
				<div class="col-start-1 col-end-5 flex flex-col text-start lg:col-start-2 lg:col-end-7">
					<span class="mb-1 text-[40px]/[110%] font-semibold lg:mb-3 lg:text-[80px]/[110%]"
						>Stay in the loop</span
					>
					<span class="mb-13 text-[20px]/[140%] sm:mb-4 lg:mb-8">Subscribe to Mill updates.</span>
					<div class="min-h-40 max-w-lg lg:min-h-36">
						<Input
							placeholder="Enter your email here"
							name="email"
							id="email"
							onsuccess={() => (successfullyEntered = true)}
						>
							<div class="pt-3">
								{#if !successfullyEntered}
									<p out:fade>
										By signing up for updates from Mill, you agree to our <a
											href="/privacy-policy"
											class="underline">Privacy Policy</a
										>.
									</p>
								{/if}
							</div>
						</Input>
					</div>
				</div>
			</Grid>
		</div>
	</GridContainer>
</div>
